import { ArrowLeft, Compass } from 'lucide-react';
import { Link } from 'react-router';

import { EmptyState } from '@/components/shared/empty-state';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="py-10">
      <EmptyState
        icon={Compass}
        title="Página no encontrada"
        description="La dirección no existe o el módulo aún no está disponible."
        action={
          <Button asChild variant="secondary" size="sm">
            <Link to="/dashboard">
              <ArrowLeft aria-hidden="true" />
              Ir al panel general
            </Link>
          </Button>
        }
      />
    </div>
  );
}
